/*
  限制输入框只能输入自然数，0,1,2,3,
  v-natural-number
*/
export const naturalNumber = {
  inserted: function(el) {
    el.addEventListener('keypress', function(e) {
      e = e || window.event
      const charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
      const re = /^[0-9][0-9]*$/
      if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      }
    })
  }
}

/*
  限制输入框只能输入数字包含小数点
  v-integer-number
*/
export const integerNumberOld = {
  inserted: function(el) {
    el.addEventListener('keypress', function(e) {
      e = e || window.event
      const charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
      const elVal = el.getElementsByTagName('input')[0].value
      const re = /\d/
      if (charcode === 46) {
        if (elVal.includes('.')) {
          e.preventDefault()
        }
      } else if (elVal.includes('-') || elVal.includes('+') || elVal.includes('e') || elVal.includes('E')) { // 负号
        e.preventDefault()
      } else if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      } else {
        if (elVal.includes('.') && (elVal.split('.')[1]).length > 1) { // 只能输入两位小数
          e.preventDefault()
        }
        if(elVal[0] == 0 && elVal[1] == 0){
          e.preventDefault()
        }
      }
    })
  }
}

/*
  下拉el-select选项滚动触底
  v-el-select-loadmore
*/
export const elSelectLoadmore = {
  inserted: function(el,binding) {
    const SELECTWRAP_DOM = el.querySelector(
      '.el-select-dropdown .el-select-dropdown__wrap'
    )
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      const condition =
        this.scrollHeight - this.scrollTop <= this.clientHeight
      if (condition) {
        binding.value()
      }
    })
  }
}

/*
  限制输入框只能输入数字包含小数点
  v-integer-number
*/

export const integerNumber = {
  inserted: function(el) {
      const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
      
      // 键盘输入限制
      input.addEventListener('keypress', function(e) {
          const charCode = e.charCode || e.keyCode;
          const val = input.value;
          
          // 阻止非数字/小数点输入
          if (!/\d|\./.test(String.fromCharCode(charCode)) && charCode > 9) {
              return e.preventDefault();
          }
          
          // 禁止重复小数点
          if (charCode === 46 && val.includes('.')) {
              return e.preventDefault();
          }
      });

      // 输入后修正
      input.addEventListener('input', function(e) {
          let val = e.target.value
              .replace(/[^\d.-]/g, '')
              .replace(/(\..*)\./g, '$1')
              .replace(/(?!^)-/g, '')
              .replace(/^(-?\d+\.\d{0,2}).*/, '$1');
              
          e.target.value = val;
      });
  }
}

/*
  限制输入框只能输入英文字母和数字
  v-alphanumeric
*/
export const alphanumeric = {
  inserted: function(el) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
    
    // 键盘输入限制
    input.addEventListener('keypress', function(e) {
      const charCode = e.charCode || e.keyCode;
      const charStr = String.fromCharCode(charCode);
      
      // 只允许字母和数字
      if (!/^[a-zA-Z0-9]$/.test(charStr) && charCode > 9 && !e.ctrlKey) {
        e.preventDefault();
      }
    });

    // 处理粘贴内容
    input.addEventListener('paste', function(e) {
      const pasteData = e.clipboardData.getData('text');
      if (!/^[a-zA-Z0-9]*$/.test(pasteData)) {
        e.preventDefault();
      }
    });

    // 输入后修正
    input.addEventListener('input', function(e) {
      e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
    });
  }
}

/*
  限制输入框只能输入中文
  v-chinese-only
*/
export const chineseOnly = {
  inserted: function(el) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
    let composing = false;
    
    // 开始拼音输入时
    input.addEventListener('compositionstart', () => {
      composing = true;
    });
    
    // 结束拼音输入时
    input.addEventListener('compositionend', (e) => {
      composing = false;
      // 对最终选中的中文进行过滤
      e.target.value = e.target.value.replace(/[^\u4e00-\u9fa5]/g, '');
    });
    
    // 输入处理
    input.addEventListener('input', function(e) {
      if (!composing) {
        // 非拼音输入时直接过滤
        e.target.value = e.target.value.replace(/[^\u4e00-\u9fa5]/g, '');
      }
    });
    
    // 键盘输入限制
    input.addEventListener('keypress', function(e) {
      if (!composing) {
        const charCode = e.charCode || e.keyCode;
        const charStr = String.fromCharCode(charCode);
        
        if (!/^[\u4e00-\u9fa5]$/.test(charStr) && charCode > 9 && !e.ctrlKey) {
          e.preventDefault();
        }
      }
    });

    // 处理粘贴内容
    input.addEventListener('paste', function(e) {
      const pasteData = e.clipboardData.getData('text');
      if (!/^[\u4e00-\u9fa5]*$/.test(pasteData)) {
        e.preventDefault();
      }
    });
  }
}

/*
  限制输入框只能输入中文
  v-chinese-onlyone
*/
export const chineseOnlyone = {
  inserted: function(el) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
    let composing = false;
    
    input.addEventListener('compositionstart', () => {
      composing = true;
    });
    
    input.addEventListener('compositionend', (e) => {
      composing = false;
      e.target.value = e.target.value.replace(/[^\u4e00-\u9fa5#]/g, '');
    });
    
    input.addEventListener('input', function(e) {
      if (!composing) {
        e.target.value = e.target.value.replace(/[^\u4e00-\u9fa5#]/g, '');
      }
    });
    
    input.addEventListener('keypress', function(e) {
      if (!composing) {
        const charCode = e.charCode || e.keyCode;
        const charStr = String.fromCharCode(charCode);
        
        if (!/^[\u4e00-\u9fa5#]$/.test(charStr) && charCode > 9 && !e.ctrlKey) {
          e.preventDefault();
        }
      }
    });

    input.addEventListener('paste', function(e) {
      const pasteData = e.clipboardData.getData('text');
      if (!/^[\u4e00-\u9fa5#]*$/.test(pasteData)) {
        e.preventDefault();
      }
    });
  }
}

/*
  限制输入框只能输入英文字母
  v-letters-only
*/
export const lettersOnly = {
  inserted: function(el) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
    
    // 键盘输入限制
    input.addEventListener('keypress', function(e) {
      const charCode = e.charCode || e.keyCode;
      const charStr = String.fromCharCode(charCode);
      
      // 只允许字母输入
      if (!/^[a-zA-Z]$/.test(charStr) && charCode > 9 && !e.ctrlKey) {
        e.preventDefault();
      }
    });

    // 处理粘贴内容
    input.addEventListener('paste', function(e) {
      const pasteData = e.clipboardData.getData('text');
      if (!/^[a-zA-Z]*$/.test(pasteData)) {
        e.preventDefault();
      }
    });

    // 输入后修正
    input.addEventListener('input', function(e) {
      e.target.value = e.target.value.replace(/[^a-zA-Z]/g, '');
    });
  }
}








// WEBPACK FOOTER //
// ./src/directive/inputBox/index.js